import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, normalizeStyle as _normalizeStyle, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, createTextVNode as _createTextVNode, withCtx as _withCtx } from "vue"

const _hoisted_1 = { class: "table-tree" }
const _hoisted_2 = { class: "table-tree__body" }
const _hoisted_3 = {
  key: 0,
  class: "table-tree__loader"
}
const _hoisted_4 = { colspan: "7" }
const _hoisted_5 = { class: "text-center" }
const _hoisted_6 = { key: 1 }
const _hoisted_7 = ["colspan"]
const _hoisted_8 = { class: "table-tree__controls" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_TableSortableHeader = _resolveComponent("TableSortableHeader")!
  const _component_TableTreeRow = _resolveComponent("TableTreeRow")!
  const _component_Loader = _resolveComponent("Loader")!
  const _component_ButtonComponent = _resolveComponent("ButtonComponent")!

  return (_openBlock(), _createElementBlock("section", _hoisted_1, [
    _createElementVNode("div", {
      class: _normalizeClass(['table-tree__wrapper', _ctx.tableClass])
    }, [
      _createElementVNode("table", {
        class: _normalizeClass({ 'table-tree__table_loading': _ctx.isLoading })
      }, [
        _createElementVNode("colgroup", null, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.columns, (column) => {
            return (_openBlock(), _createElementBlock("col", {
              key: column.field,
              style: _normalizeStyle(_ctx.getThWidth(column))
            }, null, 4))
          }), 128))
        ]),
        _createVNode(_component_TableSortableHeader, {
          columns: _ctx.columns,
          sort: _ctx.sortValue,
          headClass: "table-tree__head",
          onSortChange: _ctx.onSortChange
        }, null, 8, ["columns", "sort", "onSortChange"]),
        _createElementVNode("tbody", _hoisted_2, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.getProcessedItems, (item) => {
            return (_openBlock(), _createBlock(_component_TableTreeRow, {
              key: item._key,
              item: item,
              columns: _ctx.columns,
              expandedItems: _ctx.expandedItems,
              isHasChildren: _ctx.isHasChildren,
              onToggleExpanded: _ctx.toggleExpanded
            }, null, 8, ["item", "columns", "expandedItems", "isHasChildren", "onToggleExpanded"]))
          }), 128)),
          (_ctx.isLoading)
            ? (_openBlock(), _createElementBlock("tr", _hoisted_3, [
                _createElementVNode("td", _hoisted_4, [
                  _createElementVNode("div", _hoisted_5, [
                    _createVNode(_component_Loader)
                  ])
                ])
              ]))
            : _createCommentVNode("", true),
          (_ctx.getIsEmpty)
            ? (_openBlock(), _createElementBlock("tr", _hoisted_6, [
                _createElementVNode("td", {
                  class: "table-tree__empty-cell",
                  colspan: _ctx.getEmptyCellColspan
                }, [
                  _createElementVNode("span", null, _toDisplayString(_ctx.emptyText), 1)
                ], 8, _hoisted_7)
              ]))
            : _createCommentVNode("", true)
        ])
      ], 2)
    ], 2),
    _createElementVNode("div", _hoisted_8, [
      (_ctx.isShowPagination)
        ? (_openBlock(), _createBlock(_component_ButtonComponent, {
            key: 0,
            disabled: _ctx.isLoadingMore,
            mod: "only-blue-text",
            onClick: _ctx.onPageMore
          }, {
            default: _withCtx(() => [...(_cache[0] || (_cache[0] = [
              _createTextVNode(" Показать еще ", -1)
            ]))]),
            _: 1
          }, 8, ["disabled", "onClick"]))
        : _createCommentVNode("", true),
      (_ctx.isShowAllExpanded)
        ? (_openBlock(), _createBlock(_component_ButtonComponent, {
            key: 1,
            disabled: _ctx.isLoadingMore,
            mod: "only-blue-text",
            onClick: _ctx.expandAllItemsWithDescendants
          }, {
            default: _withCtx(() => [...(_cache[1] || (_cache[1] = [
              _createTextVNode(" Раскрыть все ", -1)
            ]))]),
            _: 1
          }, 8, ["disabled", "onClick"]))
        : _createCommentVNode("", true),
      (_ctx.isShowAllCollapsed)
        ? (_openBlock(), _createBlock(_component_ButtonComponent, {
            key: 2,
            disabled: _ctx.isLoadingMore,
            mod: "only-blue-text",
            onClick: _ctx.collapseAllItemsWithDescendants
          }, {
            default: _withCtx(() => [...(_cache[2] || (_cache[2] = [
              _createTextVNode(" Свернуть все ", -1)
            ]))]),
            _: 1
          }, 8, ["disabled", "onClick"]))
        : _createCommentVNode("", true)
    ])
  ]))
}